export default "__VITE_ASSET__Cpn0jAsq__"